import PropTypes from 'prop-types';
import React from 'react';

import I18n from 'utils/I18n';
import Settings from 'utils/Settings';
import { cn } from 'utils/Tailwind';

const PdpFreeShippingIndicator = ({ itemPrice, className }) => {
  // freeShippingThreshold is multiplied by 100 because the itemPrice
  // is received in cents.
  const thresholdMet = itemPrice > Settings.freeShippingThreshold * 100;
  const showFreeShippingIndicator = thresholdMet && Settings.freeShippingEnabled;

  if (!showFreeShippingIndicator) {
    return null;
  }

  return (
    <div
      className={cn(
        'PdpFreeShippingIndicator inline-block bg-grey p-1.5 text-center text-xs font-medium uppercase italic tracking-wider',
        className
      )}
    >
      {I18n.localize('pdp.freeShipping')}
    </div>
  );
};

PdpFreeShippingIndicator.propTypes = {
  className: PropTypes.string,
  itemPrice: PropTypes.number.isRequired,
  isMobile: PropTypes.bool,
};

PdpFreeShippingIndicator.defaultProps = {
  isMobile: false,
};

export default PdpFreeShippingIndicator;
